import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrashPermanently: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trash-permanently, remove"><path d="M4.75 6.5L5.78571 21.25H18.2143L19.25 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.25 5.75H20.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.5246 5.58289C8.73079 3.84652 10.2081 2.5 12 2.5C13.7919 2.5 15.2692 3.84652 15.4754 5.58289" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.5 10.75L14.5 15.75M14.5 10.75L9.5 15.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTrashPermanently;
